var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoProtectionStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 12.59L15.13 15.32C15.23 15.75 14.76 16.09 14.38 15.86L12 14.42L9.61 15.86C9.23 16.09 8.76 15.75 8.86 15.32L9.5 12.6L7.4 10.79C7.06 10.5 7.24 9.95 7.68 9.91L10.46 9.67L11.54 7.11C11.71 6.7 12.29 6.7 12.46 7.11L13.54 9.66L16.32 9.9C16.76 9.94 16.94 10.49 16.6 10.78L14.5 12.59ZM4.19 4.47C3.47 4.79 3 5.51 3 6.3V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V6.3C21 5.51 20.53 4.79 19.81 4.47L12.81 1.36C12.29 1.13 11.7 1.13 11.19 1.36L4.19 4.47Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoProtectionStar);
export default __webpack_public_path__ + "static/media/ico-protection-star.75df0dc5de918614c2a260d9bbe597bf.svg";
export { ForwardRef as ReactComponent };